export const SET_CONFIGS = 'SET_CONFIGS';

export default { SET_CONFIGS };



// WEBPACK FOOTER //
// ./src/actions/ConfigsActionType.js